import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saDataAccessibilityCellChartConfig } from '../cellChartConfigs';

interface DataAccessibilitySaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const DataAccessibilitySaCell: React.FC<DataAccessibilitySaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saDataAccessibilityCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default DataAccessibilitySaCell;
